module.exports = __webpack_public_path__ + "static/img/head_dome.81c9ce83.png";